module.exports = __webpack_public_path__ + "static/media/blog-2.b3abeb1e.jpg";